import React from 'react';
import { Switch, Route } from 'react-router-dom';

import PhotographyPage from 'containers/PhotographyPage';
import DigitalNomadPage from 'containers/DigitalNomadPage';
import DigitalPhotoEditingPage from 'containers/DigitalPhotoEditingPage';
import AstroPage from 'containers/AstroPage';
import TravelPage from 'containers/TravelPage';
import WorkWithMePage from 'containers/WorkWithMePage';
import ContactPage from 'containers/ContactPage';
import NotFoundPage from 'containers/NotFoundPage';

const Main = () => {
  return (
    <main>
      <Switch>
        <Route exact path='/' component={PhotographyPage} />
        <Route path='/astro-photography' component={AstroPage} />
        <Route path='/travel-photography' component={TravelPage} />
        <Route path='/freelance-web-design-development' component={DigitalNomadPage} />
        <Route path='/digital-photo-editing-retouching' component={DigitalPhotoEditingPage} />
        <Route path='/work-with-me' component={WorkWithMePage} />
        <Route path='/contact' component={ContactPage} />
        <Route exact path='*' component={NotFoundPage} />
      </Switch>
    </main>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js